// Product color palette from https://www.figma.com/file/rLsSTygVap7zagoErmncwm/Styles
// Synced from hightouch-ui (source/theme/foundations/colors.ts). Values are oklch to
// match the design system 1:1; re-sync from that file rather than editing hex by hand.
const colors = {
  teal: {
    "50": "oklch(0.98 0.0174 209.43)",
    "100": "oklch(0.9637 0.0326 212.04)",
    "200": "oklch(0.9125 0.0507 210.29)",
    "300": "oklch(0.8419 0.0658 213.26)",
    "400": "oklch(0.7487 0.1036 211.39)",
    "500": "oklch(0.5972 0.131 213.44)",
    "600": "oklch(0.5243 0.1143 214.28)",
    "700": "oklch(0.4668 0.0943 213.73)",
    "800": "oklch(0.4025 0.0826 212)",
    "900": "oklch(0.3427 0.071 210.27)",
  },
  yellow: {
    "50": "oklch(0.9871 0.0239 94.52)",
    "100": "oklch(0.9639 0.0686 97)",
    "200": "oklch(0.9249 0.1183 97.1)",
    "300": "oklch(0.8788 0.148 92.73)",
    "400": "oklch(0.8266 0.1731 86.1)",
    "500": "oklch(0.7659 0.1668 71.73)",
    "600": "oklch(0.6392 0.1581 60.07)",
    "700": "oklch(0.548 0.148 50.76)",
    "800": "oklch(0.4672 0.1315 48.45)",
    "900": "oklch(0.3748 0.1115 47.49)",
  },
  red: {
    "50": "oklch(96.91% 0.015 17.42)",
    "100": "oklch(90.23% 0.050764487400613734 18.134245085608146)",
    "200": "oklch(83.48% 0.09155694161436399 18.345986095067442)",
    "300": "oklch(76.76% 0.1379562554882739 18.596481624165502)",
    "400": "oklch(70.13% 0.19088395210545106 18.65430749379855)",
    "500": "oklch(63.33% 0.213 18.7)",
    "600": "oklch(54.91% 0.22 18.59)",
    "700": "oklch(43.46% 0.174 18.79)",
    "800": "oklch(31.64% 0.12686925279130523 18.9842584108985)",
    "900": "oklch(21.08% 0.08451422681622453 18.772611548125568)",
  },
  gray: {
    "50": "oklch(98.51% 0 355)",
    "100": "oklch(97.02% 0 355)",
    "200": "oklch(94.01% 0 0)",
    "300": "oklch(90.24% 0.0025 345.22)",
    "400": "oklch(81.84% 0.0057 3.37)",
    "500": "oklch(63.8% 0.0061 3.44)",
    "600": "oklch(50.59% 0.0082 355.05)",
    "700": "oklch(40.77% 0.0031 345.34)",
    "800": "oklch(30.18% 0.004 355)",
    "900": "oklch(23.34% 0.004 355)",
  },
  green: {
    "50": "oklch(0.96 0.0148 158.25)",
    "100": "oklch(0.9298 0.0478 156.56)",
    "200": "oklch(0.856 0.0977 154.31)",
    "300": "oklch(0.7761 0.1295 152.9)",
    "400": "oklch(0.6717 0.1422 153.17)",
    "500": "oklch(0.5904 0.1616 152.22)",
    "600": "oklch(0.4551 0.1329 155.25)",
    "700": "oklch(0.3832 0.1031 156.41)",
    "800": "oklch(0.3277 0.0924 157.43)",
    "900": "oklch(0.3034 0.0685 169.68)",
  },
  blue: {
    "50": "oklch(0.9709 0.0125 255.5)",
    "100": "oklch(0.9338 0.0348 259.59)",
    "200": "oklch(0.883 0.0625 259.03)",
    "300": "oklch(0.8115 0.0996 256.56)",
    "400": "oklch(0.707 0.158 259.16)",
    "500": "oklch(0.6199 0.2108 263.3)",
    "600": "oklch(0.5178 0.2286 265.2)",
    "700": "oklch(0.4803 0.2313 266.03)",
    "800": "oklch(0.4043 0.2004 267.27)",
    "900": "oklch(0.321 0.1378 267.64)",
  },
  purple: {
    "50": "oklch(0.9575 0.0114 308.33)",
    "100": "oklch(0.8997 0.0245 306.94)",
    "200": "oklch(0.8076 0.0506 307.77)",
    "300": "oklch(0.727 0.0731 307.34)",
    "400": "oklch(0.6511 0.0936 307.59)",
    "500": "oklch(0.5972 0.1079 307.75)",
    "600": "oklch(0.524 0.1061 307.91)",
    "700": "oklch(0.4362 0.0889 307.9)",
    "800": "oklch(0.3393 0.0694 308.56)",
    "900": "oklch(0.2977 0.0622 308.08)",
  },
  pink: {
    "50": "oklch(97.18% 0.011 339.33)",
    "100": "oklch(94.76% 0.023 338.62)",
    "200": "oklch(89.55% 0.051 340.45)",
    "300": "oklch(81.57% 0.1 343.67)",
    "400": "oklch(70.56% 0.171 347.84)",
    "500": "oklch(64.07% 0.205 352.56)",
    "600": "oklch(57.55% 0.214 359.48)",
    "700": "oklch(51.08% 0.191 2.82)",
    "800": "oklch(44.62% 0.16 2.77)",
    "900": "oklch(39.84% 0.13 1.02)",
  },
  orange: {
    "50": "oklch(98.1% 0.015 80.71)",
    "100": "oklch(95.42% 0.034 80.31)",
    "200": "oklch(89.96% 0.083 73.51)",
    "300": "oklch(83.26% 0.134 68.84)",
    "400": "oklch(74.21% 0.173 57.75)",
    "500": "oklch(69.47% 0.196 49.2)",
    "600": "oklch(63.37% 0.196 42.09)",
    "700": "oklch(54.13% 0.178 39.62)",
    "800": "oklch(46.06% 0.155 38.44)",
    "900": "oklch(36.7% 0.123 39.51)",
  },
  indigo: {
    "50": "oklch(94.96% 0.023 291.37)",
    "100": "oklch(91.63% 0.042 291.47)",
    "200": "oklch(84.1% 0.075 290.63)",
    "300": "oklch(78.42% 0.091 290.6)",
    "400": "oklch(67.89% 0.122 289.83)",
    "500": "oklch(57.6% 0.135 289.1)",
    "600": "oklch(46.86% 0.135 287.37)",
    "700": "oklch(38.9% 0.124 288.18)",
    "800": "oklch(31.66% 0.099 289.01)",
    "900": "oklch(20.7% 0.108 289.18)",
  },
};

// Legacy scale aliases. Docs code still references these names directly
// (forest.*, space.*, grass.*); keep them pointing at the synced scales so the
// design-system move (forest -> teal) doesn't require touching every call site.
const forest = { ...colors.teal };
const space = { ...colors.indigo };
const grass = { ...colors.green };

const themeColors = {
  ...colors,
  forest,
  space,
  text: {
    primary: colors.gray["800"],
    secondary: colors.gray["700"],
    tertiary: colors.gray["600"],
    placeholder: colors.gray["600"],
    danger: colors.red["600"],
    disabled: colors.gray["500"],
    upsell: colors.purple["700"],
    warning: colors.yellow["700"],
    success: colors.green["700"],
  },
  base: {
    border: colors.gray["300"],
    borderDisabled: colors.gray["200"],
    borderHover: colors.gray["400"],
    divider: colors.gray["200"],
    background: colors.gray["100"],
    backgroundHover: colors.gray["200"],
    lightBackground: colors.gray["50"],
    backgroundDisabled: colors.gray["200"],
  },
  primary: {
    pressed: colors.teal["800"],
    hover: colors.teal["700"],
    base: colors.teal["600"],
    border: colors.teal["300"],
    background: colors.teal["50"],
    backgroundHover: colors.teal["100"],
    text: colors.teal["700"],
  },
  teal: {
    ...colors.teal,
    dark: colors.teal["800"],
    hover: colors.teal["700"],
    base: colors.teal["600"],
    border: colors.teal["300"],
    background: colors.teal["50"],
    backgroundHover: colors.teal["100"],
    text: colors.teal["700"],
    pressed: colors.teal["800"],
  },
  green: {
    ...colors.green,
    base: colors.green["600"],
    border: colors.green["300"],
    background: colors.green["50"],
    backgroundHover: colors.green["100"],
    text: colors.green["700"],
    pressed: colors.green["800"],
  },
  grass: {
    ...grass,
    base: colors.green["600"],
    border: colors.green["300"],
    background: colors.green["50"],
  },
  success: {
    base: colors.green["600"],
    hover: colors.green["700"],
    border: colors.green["300"],
    background: colors.green["50"],
    backgroundHover: colors.green["100"],
    text: colors.green["700"],
    pressed: colors.green["800"],
  },
  warning: {
    ...colors.yellow,
    base: colors.yellow["600"],
    hover: colors.yellow["700"],
    border: colors.yellow["300"],
    background: colors.yellow["50"],
    backgroundHover: colors.yellow["100"],
    text: colors.yellow["700"],
    pressed: colors.yellow["800"],
  },
  danger: {
    ...colors.red,
    dark: colors.red["800"],
    hover: colors.red["700"],
    base: colors.red["600"],
    border: colors.red["200"],
    background: colors.red["50"],
    backgroundHover: colors.red["100"],
    text: colors.red["700"],
    pressed: colors.red["800"],
  },
  upsell: {
    dark: colors.purple["800"],
    hover: colors.purple["700"],
    base: colors.purple["600"],
    border: colors.purple["300"],
    background: colors.purple["50"],
    backgroundHover: colors.purple["100"],
    text: colors.purple["700"],
    disabled: colors.purple["200"],
  },
  link: {
    pressed: colors.teal["800"],
    hover: colors.teal["700"],
    default: colors.teal["600"],
  },
  brand: {
    black: "#101111",
    accent: "#40DE9E",
  },
};

export default themeColors;

export type Colors = typeof themeColors;
